<div class="cotizador">
  <banner-app [Fixtop]="''" [retroSelected]="false" [showPromo]="true"></banner-app>

  <div *ngIf="enablePromo" class="w-100 d-block d-md-none contenedor-promo-mobile">
    <img class="img-promo-mobile" src="{{ bannerImgMobile }}" [width]="360" [height]="265" priority
      alt="Promoción e-SIM 10GB incluidos" />
  </div>

  <app-info-mensaje></app-info-mensaje>

  <main class="cotizador__main">
    <div class="container">
      <div class="row">
        <!-- Sección de presentación -->
        <section class="col cotizador__presentation">
          <!-- Desktop -->
          <div *ngIf="enablePromo" class="cotizador__content cotizador__content--desktop">
            <header class="cotizador__header">
              <h1 class="cotizador__title">
                {{ bannerTitleLine1 }}<br />
                {{ bannerTitleLine2 }}
              </h1>
            </header>

            <div class="cotizador__media">
              <img src="{{ bannerImgDesktop }}" priority alt="Promoción e-SIM 10GB incluidos" />
            </div>
          </div>

          <div *ngIf="!enablePromo" class="cotizador__content cotizador__content--desktop">
            <header class="cotizador__header">
              <h1 class="cotizador__title">
                Vamos a cotizar el<br />
                seguro voluntario para motos
              </h1>
            </header>

            <div class="cotizador__media">
              <app-webm-player src="./assets/img/motoAnimation.webm" alt="Seguro de moto" width="90%" height="auto"
                cssClass="w-90" />
            </div>
          </div>

          <!-- Mobile -->
          <div *ngIf="enablePromo" class="cotizador__content cotizador__content--mobile">
            <header class="cotizador__header">
              <h1 class="cotizador__title">
                {{ bannerTitleLine1 }}<br />
                {{ bannerTitleLine2 }}
              </h1>
            </header>
          </div>
          <div *ngIf="!enablePromo" class="cotizador__content cotizador__content--mobile">
            <header class="cotizador__header">
              <h1 class="cotizador__title">
                Vamos a cotizar tu seguro de Motos SURA
              </h1>
            </header>
          </div>
        </section>

        <!-- Sección de formulario -->
        <section class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0 cotizador__form-section ml-md-2">
          <app-initial-form [codigoAsesor]="codigoAsesor" [states]="states" [destinos]="destinos"
            [prefilledData]="prefilledFormData" (formSubmit)="onFormSubmit($event)"
            (criticalFieldsComplete)="onCriticalFieldsComplete($event)" (advisorSelected)="onAdvisorSelected($event)"
            (termsModalRequested)="onTermsModalRequested()"></app-initial-form>
        </section>
      </div>
    </div>
  </main>

  <app-footer-app class="footer-fixed" />
</div>